import { RATES_SOURCES, formatUpdated, type RatesKey } from "./taxSources";

/** Tax year, source and "rates last updated" line shown under every rate-based calculator. */
export function RatesNote({ id }: { id: RatesKey }) {
  const r = RATES_SOURCES[id];
  return (
    <div className="rounded-lg border bg-muted/30 px-3 py-2 text-xs text-muted-foreground" data-testid={`rates-note-${id}`}>
      <p>
        <span className="font-medium text-foreground">Tax year:</span> {r.year} ·{" "}
        <span className="font-medium text-foreground">Source:</span>{" "}
        <a href={r.url} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2">{r.source}</a> ·{" "}
        <span className="font-medium text-foreground">Rates last updated:</span> {formatUpdated(r.updated)}
      </p>
      <p className="mt-1">
        {r.status === "checked"
          ? "Compared with the official figures on that date."
          : "Compiled as an estimate; confirm with the official source before you rely on it."}{" "}
        Next review: {r.nextReview}.
      </p>
    </div>
  );
}
